module.exports = __webpack_public_path__ + "76058448f79b8237053d3d14a2ab721b.pdf";